import axios from 'axios'
import { STOCKS_ENDPOINT } from '../../endpoints'

export async function getStock(id, query) {
  if(query && query.indexOf('?') === -1) {
    query = `?${query}`;
  }
  const response = await axios.get(`${STOCKS_ENDPOINT}/${id}${query}`)
  return response.data.data;
}
